__turbopack_context__.v({
  "sideBarDrag": "Layout-module__MO-Z0W__sideBarDrag",
  "sideBarDragActive": "Layout-module__MO-Z0W__sideBarDragActive",
});
